//-*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"

// MUI
import {  withStyles } from "@material-ui/core/styles"

// D3
import * as d3 from "d3" 

import * as _ from "lodash"
import moment from "moment"

import {
    distinct,
    groupBy
} from "../../Utils.js"

import {
    genRichTickValues
} from "../../../bl/A/bl.js"

// LOGGING SETUP
import appConfig from "./../../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<DashLineChart>")


const styles = theme => ({
//    sheet_old: {
//        margin: 0,
//        padding: 0,
//        borderWidth: "0.3em",
//        borderStyle: "dotted",
//        borderColor: "grey",
//    },
    chartDiv: {
        position: "relative",
        width: "100%", // this is working
        height: "100%",
        margin: 0,
        padding: 0,
        // borderWidth: "4px", // we set that as a prop
        borderStyle: "dotted",
        borderColor: "grey",
        // backgroundColor: "#f7f6f6"
        backgroundColor: "white", // color inside the
        "& :hover": {
            // backgroundColor: "black" // color inside the
        }
    },
    chartSvg: {
        margin: 0,
        padding: 0,

    },
    
    circleExample: {
        r: 50,
        cx: 50,
        cy: 50
    },

    removed: {
        display: "none"
    },

    xAxis: {
        '& path': {
            display: "none"
        }
    },

    yAxis: {
        '& path': {
            display: "none"
        }
    },

    xTimeAxis: {
        '& path': {
            fill: "none",
            stroke: "#448cff",
            strokeWidth: "4px"
        },
        '& .tick': {
            "& line": {
                fill: "none",
                stroke: "#448cff",
                strokeWidth: "5px"
            },
            "& text": {
                marginLeft: "20px",
                fontSize: "13px",
                fontWeight: "normal",
                color: "#2d7eff",
            }
        }
    },


    yTimeAxis: {
        '& path': {
            fill: "none",
            stroke: "#448cff",
            strokeWidth: "2px",
            display: "none"
        },
        '& .tick': {
            "& line": {
                fill: "none",
                stroke: "#448cff",
                strokeWidth: "2px",
                "display": "none",
            },
            "& text": {
                fontSize: "14px",
                fontWeight: "normal",
                // fontWeight: "bold",                
                color: "#2d7eff",
            }
        }
    },

    
    bar1: {
        fill: "#438CFF"
    },
    
    bar2: {
        fill: "#006EDD",
        opacity: 0.5
    },

    trend1Line: { // this applies at the "g" level to the whole thing
        '& path': {
            fill: "none",
            stroke: "#448cff",
            strokeWidth: "5px",
            opacity: 1
        }
    },

    trend1LineHighlight: { // this applies at the "g" level to the whole thing
        '& path': {
            fill: "none",
            // stroke: "#448cff",
            stroke: "#448cff!important",
            strokeWidth: "5px",
            opacity: "1!important"
        }
    },

    trend1LineEmpty: { // this applies at the "g" level to the whole thing
        '& path': {
            fill: "none",
            // stroke: "#448cff",
            // stroke: "red!important",
            // stroke: "red",
            strokeWidth: "5px",
            opacity: 0
        }
    },

    trend1CircleEmpty: {
        opacity: "0!important"
    },

    trend1CircleHighlight: {
        opacity: "1!important"
    },
    
    
    trend1Circle: {
        fill: "#448cff",
        stroke: "white",
        strokeWidth: "1px"
    },

    trend1CircleLastWeek: {
        fill: "#ff9800", // orange
        // stroke: "grey"
        stroke: "white"
    },

    trendCircleUp: {
        //        fill: "green",
        fill: "#00bf00",
        //stroke: "grey"
        stroke: "white"
    },

    trendCircleDown: {
        // fill: "red",
        // fill: "#d65151",
        fill: "#ff3333",
        // stroke: "grey"
        stroke: "white"
    },

    trendCircleSame: {
        fill: "black",
        // stroke: "grey"
        stroke: "white"
    },
    
    
    marker1: {
    },

    listener: {
        fill: "transparent",
    },

    //
    //  tooltip stuff
    //
    tooltip: {
        position: "absolute", // will be absolute to the "wrapper" and parallel to the sheet
        display: "none", // do not display at first
        //        top: "-12px",
        left: "0",
        padding: "0.6em 1em",
        background: "#fff",
        //   background: "red",
        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        transition: "all 0.2s ease-out",
        pointerEvents: "none",
    },

    tooltipAnchor_old: {
//        content: '',
        position: "relative",
        bottom: "-9px",
        left: "50%",
        width: "12px",
        height: "12px",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        transform: "translate(-50%, 50%) rotate(45deg)",
        transformOrigin: "center center",
        zIndex: 10
    },

    tooltipAnchor: {
        position: "absolute",
        width: "12px",
        height: "12px",
        bottom: "-0",
        left: "50%",
        transform: "translate(-50%, 50%) rotate(45deg)",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        // backgroundColor: "red",
        // transformOrigin: "center center", // we don't need this
    }
    
})

class DashLineChart extends Component {

    static defaultProps = {
        bar1Spacing: 10,
        bar2Spacing: 2,
        showXAxis: false,
        showYAxis: false,
        showBar1: true,
        showBar2: true,
        borderWidth: 0,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingInner: 0,// 0.1
        reverseY: false
    }


    constructor(props) {
        super(props)

        const { dataset, superset,
                // eslint-disable-next-line                
                subset } = this.props
        this.dataset = dataset
        this.superset = superset
        
        log.trace("constructor(): dataset =", this.dataset)

        // we don't need to have those to be part of the state
        // cause it's chart-only
        this.showCircle = true

        this.state = {
            minX: 0,
            firstTime: true
        }
        
    }

    handleChartClick = () => {
        // eslint-disable-next-line
        const { classes } = this.props

        log.trace("DashBarChar: handleChartClick(): this =", this)

        //        d3.select(this.refs.chartSvg).select(`#circle-1`)
        //        .classed(classes.removed, !this.showCircle)
        //        this.showCircle = !this.showCircle
        // this.setState({minX: this.state.minX + 1})
    }

    calcDims = () => {

        const { bar1Spacing,
                bar2Spacing,
                borderWidth,
                paddingTop, paddingRight, paddingBottom, paddingLeft, paddingInner
              } = this.props

        log.trace("DashBarChar: calcDims(): borderWidth =", borderWidth)
        
        let paintMargin = {top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft, inner: paddingInner}
//        const paintMargin = {top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft}
        //let margin = {top: 0, right: 0, bottom: 0, left: 0}

        // x-axis shows up in the bottom margin
        // top: works ok, just a bit of maring, but good for now
        // right: ok
        // bottom: the x-axis shows up in the bottom margin -ok
        // left: y-axis shows up on the left margin - ok
        // let margin = {top: 20,  right: 20, bottom: 30, left: 30}
        
        const chartDiv = d3.select(this.refs.chartDiv)
        const chartWidth = chartDiv.node().getBoundingClientRect().width
        const chartHeight = chartDiv.node().getBoundingClientRect().height
        const paintWidth = +chartWidth - paintMargin.left - paintMargin.right
        const paintHeight = +chartHeight - paintMargin.top - paintMargin.bottom

        this.dims = {
            chart: { // total chart div dimensions
                width: chartWidth,
                height: chartHeight
            },
            svg: { // svg tag size and other attributes
                width: chartWidth - borderWidth * 2,
                height: chartHeight - borderWidth * 2 + 27, // without the +27 we don't see xaxis at all
//                height: chartHeight - borderWidth * 2 + 20 + 40, // +20 is for the xaxis
                                                            // another + 40 is for xTimeAxis
                viewBox: `0 0 ${chartWidth - borderWidth}px ${chartHeight - borderWidth}px`, // chartSvg
            },
            paint: { // actual paint sizes, this is what the transforms are made on
                width: paintWidth,
                height: paintHeight,
                margin: paintMargin
            },
            bar1: {
                spacing: bar1Spacing
            },
            bar2: {
                spacing: bar2Spacing
            },
            marker1: {
                width: 10
            },
            border: {
                width: borderWidth
            },
        }

        log.trace("DashBarChar: calcDims(): bar1Spacing =", bar1Spacing)
        log.trace("DashBarChar: calcDims(): this.dims =", this.dims)
        
    }

    createTransform = (x,y,k) => {
        if(k) {
            return `translate(${x},${y}) scale(${k})`
        } else {
            return `translate(${x},${y})`
        }
    }

    /*
    getFirst_old = (data) => {
        return data.reduce((min, val) => {
	    return moment(min.flashTimestamp).diff(val.flashTimestamp)
	        ? min
	        : val
        }, data[0])
    }

    getLast_old = (data) => {
        return data.reduce((max, val) => {
            log.trace("getLast(): comparing max =", max)
            log.trace("getLast(): comparing val =", val)
            let retVal = moment(max.flashTimestamp).diff(moment(val.flashTimestamp))
	        ? val
	        : max
            log.trace("getLast(): returning retVal =", retVal)
            
//	    return moment(max.flashTimestamp).diff(moment(val.flashTimestamp))
//	        ? val
//	        : max
        }, data[0])
    }
    */
    
    getLast = (data) => {
        let last = data[0]
        let compare
        data.forEach(d => {
            log.trace("getLast(): last =", last.flashTimestamp)
            log.trace("getLast(): d =", d.flashTimestamp)
            compare = moment(last.flashTimestamp).diff(moment(d.flashTimestamp))
            log.trace("getLast(): compare =", compare)
            if(compare < 0) {
                last = d
            }
        })
        return last
    }

    getFirst = (data) => {
        let first = data[0]
        let compare
        data.forEach(d => {
            compare = moment(first.flashTimestamp).diff(moment(d.flashTimestamp))
            if(compare > 0) {
                first = d
            }
        })
        return first
    }
    

    getMin = (data) => {
        return data.reduce((min, val) => {
	    return min.flashValue < val.flashValue
	        ? min
	        : val
        }, data[0])
    }

    getMax = (data) => {
        return data.reduce((max, val) => {
	    return max.flashValue > val.flashValue
	        ? max
	        : val
        }, data[0])
    }


    /*
    resetChart = () => {

        const svg = d3.select(this.refs.chartSvg)
        
        const prevCircles =
              svg
              .selectAll("#multi-chart-g")
              .selectAll("#chart-line-circle")
        log.debug("drawChart(): DEL: prevCircles =", prevCircles)
        prevCircles.remove()
        }
*/

    drawChart = () => {

        const { classes,
                showXAxis, showYAxis,
                showBar1, showBar2,
                showHighlights, highlights, startEmpty,
                reverseY
              } = this.props

        log.trace("drawChart(): this.dataset =", this.dataset)
        log.trace("drawChart(): showHighlights =", showHighlights)
        log.trace("drawChart(): highlights =", highlights)
        log.trace("drawChart(): startEmpty =", startEmpty)


        this.calcDims()


        log.trace("drawChart(): DAILY: this.dims.chart =", this.dims.chart)
        log.trace("drawChart(): DAILY: this.dims.svg =", this.dims.svg)
        log.trace("drawChart(): DAILY: this.dims.paint =", this.dims.paint)

        const chart = d3.select(this.refs.chartDiv)
        chart.style("border-width", `${this.dims.border.width}px`)
        
        log.trace("drawChart(): this.dims.paint.width =", this.dims.paint.width)
        
        const x = d3.scaleLinear().rangeRound([0, this.dims.paint.width]);
        
        //        const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(0.1);
        const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(this.dims.paint.margin.inner)

        x.domain([0,1000])
        log.trace("drawChart(): initial x(0) =", x(0))
        log.trace("drawChart(): inttial x(1) =", x(200))

        // this domain and scale are chart based, not paint based ast for regular bars
        const yListener = d3.scaleBand().rangeRound([0,this.dims.chart.height])

        const svg = d3.select(this.refs.chartSvg)
        
        svg
            .style("width", this.dims.svg.width)
            .style("height", this.dims.svg.height)


        // https://stackoverflow.com/questions/34088550/d3-how-to-refresh-a-chart-with-new-data
        d3.select(this.refs.chartSvg).select("g").remove() // reset the svg + g
        const g = svg.append("g")
              .attr("transform", `translate(${this.dims.paint.margin.left},${this.dims.paint.margin.top})`)

        if(this.superset) {
            log.trace("DashBarChar: drawChart(): HAS superset")
        } else {
            log.trace("DashBarChar: drawChart(): NO superset")
        }
        
        if(this.superset) {
            x.domain([0,
                      // we can not have 0 here, max has to be at least 1
                      // for datasets with all 0's, be low will return "at least" 1
                      _.max([1,d3.max(this.superset, d => d.col1)]) // 
                     ])
        } else {
            x.domain([0, _.max(1,d3.max(this.dataset, d => d.col1))
                     ])
        }

        // this y are labels, yTimeScale are values for the y's of the line chart
        y.domain(this.dataset.map( d => {
            return d.name;
        }))

        log.trace("drawChart(): after superset x(0) =", x(0))
        log.trace("drawChart(): after superset x(1) =", x(200))

        
        yListener.domain(this.dataset.map( d => {
            return d.name;
        }))

        
        log.trace("DashBarChar: constructor(): this.dims.svgHeight =", this.dims.svgHeight)

        //https://github.com/d3/d3-axis#axis_tickValues
        //https://stackoverflow.com/questions/13100314/change-the-ticks-on-x-axis#13102118
        //        const xAxisFunc = d3.axisBottom(x).tickValues(d3.range(0,1000,450))
        //        xAxisFunc.tickValues(d3.range(0,300))

        const xAxisFunc = d3.axisBottom(x)
        
        if(showXAxis) {
            g.append("g")
                .attr("class", classes.xAxis)
                .attr("transform", `translate(0,${this.dims.paint.height})`) // this transforms it vertical
                .call(xAxisFunc)
            //.call(d3.axisBottom(x).tickValues(d3.range(0,10000,450))) // nice specific range starting with 0,range 450
        }

        if(showYAxis) {
            g.append("g")
                .attr("class", classes.yAxis)
                .call(d3.axisLeft(y))
        }

        if(showBar1) {
            // bar1 = col1, dark blue
            g.selectAll(".bar1")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", classes.bar1)
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar1.spacing/2)
                .attr("width", d => {
                    const widthValue = x(d.col1)
                    log.trace("drawChart(): d =",d)
                    log.trace("drawChart(): widthValue =", widthValue) // debug here why so high
                    return widthValue
                }
                     ) 
                .attr("height", y.bandwidth() - this.dims.bar1.spacing);
        }

        if(showBar2) {
        // bar2 = col2, light blue
            g.selectAll(".bar2")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", classes.bar2)
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar2.spacing/2)
                .attr("width", d => x(d.col2))
                .attr("height", y.bandwidth() - this.dims.bar2.spacing)
        }


        // all the yAxis stuff
        // TODO: currently defaults to dataset[0], should be looking at all of
        // the superset
        if(true) {
            // get all the datapoints into 1 array so that we can
            // calculate the boundaries for all of them
            let allTrends = []
            this.dataset.forEach(dataset => {
                allTrends = allTrends.concat(dataset.trend1) 
            })

            if(allTrends.length === 0) {
                log.trace("drawChart(): WARNING: no allTrends datata, returning early")
                return
            }
            
            const firstData = this.getFirst(allTrends)
            const lastData = this.getLast(allTrends)
            const minData = this.getMin(allTrends)
            const maxData = this.getMax(allTrends)

            log.trace("drawChart(): V3: allTrends =", allTrends)
            const groupedAllTrends = groupBy(allTrends, trend => {
                if(trend.statement) {
                    return `${trend.issue.slug}->${trend.statement.slug}: ${trend.YEAR_N}-w${trend.WEEK_N}-${trend.DAY_N}`
                } else {
                    return `${trend.issue.slug}: ${trend.YEAR_N}-${trend.WEEK_N}-${trend.DAY_N}`
                }
            })
            log.trace("drawChart(): V3: groupedAllTrends =", groupedAllTrends)
            
            
            log.trace("drawChart(): V3  firstData =", firstData)
            log.trace("drawChart(): V3: lastData =", lastData)
            log.trace("drawChart(): DEL: minData =", minData)
            log.trace("drawChart(): DEL: maxData =", maxData)

            // NEXT: first data and last data are the same
            // in the case of the statement, we must not be going through all the weeks
            log.trace("drawChart(): firstData.flashTimestamp =", firstData.flashTimestamp)
            log.trace("drawChart(): lastData.flashTimestamp =", lastData.flashTimestamp)
            log.trace("drawChart(): minData.flashValue =", minData.flashValue)
            log.trace("drawChart(): maxData.flashValue =", maxData.flashValue)

            
            const xTimeScale = d3.scaleLinear().domain([
    	        firstData.flashTimestamp,
    	        lastData.flashTimestamp
            ]).range([0, this.dims.paint.width])

            /*
             153.82684101014206
             307.6536820202841
              517
            */
            

/*
            const yTimeScale = reverseY ?
                  d3.scaleLinear().domain([
	              maxData.flashValue,
	              minData.flashValue
	          ]).range([this.dims.paint.height - 10, 0]) // -10 to adjust the curve hitting the x-scale
                :
                  d3.scaleLinear().domain([
	              minData.flashValue,
	              maxData.flashValue
	          ]).range([this.dims.paint.height - 10, 0]) // -10 to adjust the curve hitting the x-scale
*/


            const yTimeScale = reverseY ?
                  d3.scaleLinear().domain([
	              Math.ceil(maxData.flashValue),
	              Math.floor(minData.flashValue)
	          ]).range([this.dims.paint.height - 10, 0]) // -10 to adjust the curve hitting the x-scale
                :
                  d3.scaleLinear().domain([
	              Math.floor(minData.flashValue),
	              Math.ceil(maxData.flashValue)
	          ]).range([this.dims.paint.height - 10, 0]) // -10 to adjust the curve hitting the x-scale
            
            log.trace("drawChart(): reverseY =", reverseY)
            log.trace("drawChart(): reverseY yTimeScale(0) =", yTimeScale(1))
            log.trace("drawChart(): reverseY yTimeScale(1.67) =", yTimeScale(1.67))
            log.trace("drawChart(): reverseY yTimeScale(2.33) =", yTimeScale(2.33))
            log.trace("drawChart(): reverseY yTimeScale(4) =", yTimeScale(4))
            // generate path
            const lineGenerator = d3.line()
	          .x((d,i) => {
	              return xTimeScale(d.flashTimestamp)
    	          })
	          .y((d,i) => {
                      log.trace("drawChart(): reverseY d.value =", d.value)
	              return yTimeScale(d.value)
	          })
                  // .curve(d3.curveCardinal.tension(0.5))
                  .curve(d3.curveCardinal.tension(1))

            //const pathData = lineGenerator(this.dataset[0].trend1)
            //            log.trace("drawChart(): pathData =", pathData)

            const xAxisTransform = this.createTransform(
                0,
                this.dims.paint.height + 10                
            )

            // X TIME AXIS
            log.trace("drawChart(): xAxisTransform =", xAxisTransform)

            if(!this.dataset) {
                log.trace("drawChart(): WARNING: no this.dataset")
                return 
            }

            if(!this.dataset[0]) {
                log.trace("drawChart(): WARNING: no this.dataset[0]")
                return 
            }

            if(!this.dataset[0].trend1) {
                return 
            }


            // these tick values don't work, let's get all the timestamp
            // from all the trends, because each trend while co-ordinated with others t0...tX
            // it may be partial so some of the might just have a subset of all the timestamps
            // that we want to show on the chart, so drill through all of them and
            // put them in the common pool and deal them
            // NEXT: do here

            log.trace("drawChart(): ticks: allTrends = ", allTrends)
            // original distict was not doing the job on the timestamp type comarisson
            // so we're doing distinct on strings and then converting it back to Date
            const allTickValues = distinct(allTrends, (trend) => {
                return "" + trend.timestamp
            }).map(t => new Date(t)) 

            log.trace("drawChart(): ticks: allTickValues = ", allTickValues)


            /*
            const allTickValues = this.dataset[0].trend1.map(t => {
                return t.flashTimestamp
            })
            */

            // HACK
            //allTickValues.push(new Date(1970, 1, 8), new Date(1970, 1, 9))

            let tickValues = []
            // for(let i = 0; i < allTickValues.length; i++) {
            for(let i = allTickValues.length - 1; i >= 0; i--) {
                /*
                if(allTickValues[i + 1]) { // look-ahead
                    if(moment(allTickValues[i + 1]).diff(moment(allTickValues[i]), 'days') >= 1) { // this will eliminate ajacent days
                        tickValues.push(allTickValues[i])
                    }
                    log.trace("debug(): ticks: i = ", i)
                    log.trace("debug(): ticks: pushed tick value, allTickValues[i] = ", allTickValues[i])
                } else {
                    // this is for under the week, most recent one
                    tickValues.push(allTickValues[i])
                }
                */
                if((allTickValues.length - 2) === i) {
                    // skip the tick that's previous to latest TODO: do the other logic that will
                    // show it if the day difference is more t
                    tickValues.push(allTickValues[i]) // dont' skip
                } else {
                    tickValues.push(allTickValues[i])
                }
            }


            //
            // HACK again
            //
            //tickValues = [new Date(1970, 1, 8), new Date(1970, 1, 9)]
            

            // HACK
            //tickValues = [new Date(1970, 1, 8), new Date(1970, 1, 9)]
            
            
//            const yTickValues = this.dataset[0].trend1.map(t => {
//                return Math.floor(t.flashValue)
//            })


            //const feb8Date = moment("2021-02-08");
            //const feb8Date = new Date(2021, 2, 8)
            //log.trace("drawChart(): feb8Date =", feb8Date)
            // log.trace("drawChart(): tickValues =", tickValues)
            
            //log.trace("drawChart(): tickValues =", tickValues)
            
            const yTickValues = []

            let minTickValue = Math.floor(minData.flashValue)
            //let minTickValue = 1
            let maxTickValue = Math.ceil(maxData.flashValue)
            for(let i = minTickValue; i <= maxTickValue; i++) {
                yTickValues.push(i)
            }
            
            // allTickValues.push(new Date(1970, 1, 8), new Date(1970, 1, 9))
            // Mon Feb 09 1970 16:00:02 GMT-0800 (Pacific Standard Time)
            // tickValues.push(new Date(1970, 1, 8), new Date(1970, 1, 9))
            // tickValues.push(new Date(1970, 1, 9), new Date(1970, 1, 8), new Date(1970, 1, 15))xr


            //
            // All the tickValue stuff above is kind of bs, do it again here
            //
            tickValues = []
            tickValues = allTickValues
            log.trace("drawChart(): DAILY: tickValues.length =", tickValues.length)
            log.trace("drawChart(): DAILY: tickValues =", tickValues)
            log.trace("drawChart(): DEL: yTickValues =", yTickValues)

            // TEMP
            //tickValues = genRichTickValues(allTickValues)
            log.trace("drawChart(): DAILY: before tickValues =", tickValues)
            
            //tickValues = allTickValues.map(tick => ({tick}))

            const isDaily = allTrends.find(stat => stat.DAY_N > 0) ? true : false
            log.trace("drawChart(): DAILY: isDaily =", isDaily)
            
            //for(let trend of allTrends) {
            //                log.debug("drawChart(): DAILY: trend =", trend)
            //            }

            // 40.5 is width of the "Feb 28" for example
            const labelWidth = 40.5
            const depth = Math.floor(this.dims.paint.width / labelWidth / 6)
            log.trace("drawChart(): DAILY: size this.dims.paint =", this.dims.paint)
            log.trace("drawChart(): DAILY: size depth =", depth)
            
            
            if(isDaily) {
                tickValues = genRichTickValues(allTickValues, "DAY", depth)
            } else {
                tickValues = genRichTickValues(allTickValues, "WEEK", depth)
            }

            log.trace("drawChart(): DAILY: after tickValues =", tickValues)

            // NEXT: have yTickValues to be exact, we need to have an array going from 1 to max
            
            // xTickValues
            // we need to select current tick values and delete them

            /*
            const before = g.selectAll("[isXTickAxis=true]")
            log.debug("drawChart(): DEL: before isXTickAxis =", before)

            const beforeTicks = before.selectAll(".tick")
            log.debug("drawChart(): DEL: beforeTicks =", beforeTicks)
            */
            

            log.trace("drawChart(): DEL: this.state.firstTime =", this.state.firstTime)
            if(this.state.firstTime) {
                this.setState({firstTime: false})
            }

            /*
            const prevTicks = d3
                  .select(this.refs.chartSvg)
                  .select("g")
                  .select("g")
                  .selectAll(".tick")
            */

/*
            const prevTicks =
                  svg
//                  .select("g")
//                  .select("g")
                  .selectAll(".tick")
            
            // before is all the ticks so delete them
            prevTicks.remove()
*/
            
//            if(this.state.firstTime) {
                g.append("g")
//                    .attr("isXTickAxis", true)
	            .attr("transform",xAxisTransform)
                    .attr("class", classes.xTimeAxis)
                    .call(d3.axisBottom(xTimeScale)
                          //                          .tickValues(tickValues.map(to => to.tick))
                          .tickValues(tickValues.map(to => to.peg))
	                  .tickFormat((a, b) => {
                              // return d3.timeFormat("%b %d")
                              log.trace("drawChart(): DAILY: ticks a =", a)
                              log.trace("drawChart(): DAILY: ticks b =", b)
                              // return "blah"
                              // b is the counter here starting with 0 as the last one
                              const richTick = tickValues[b]
                              log.trace("drawChart(): DAILY: richTick =", richTick)
                              /*
                              if(b === 1) {
                                  //return ""
                                  return d3.timeFormat("%b %d")(a)
                              } else {
                                  return d3.timeFormat("%b %d")(a)
                              }
                              */
                              /*
                              if(richTick.isTextVisible === 'undefined') {
                                  return d3.timeFormat("%b %d")(a)
                              } else if(richTick.isTextVisible === true) {
                                  return d3.timeFormat("%b %d")(a)
                                  //                              } else if(richTick.isTextVisible === 'undefined' || richTick.isTextVisible === false) {
                              } else if(true) {
                                  return d3.timeFormat("%d")(a)
                              }
                              */


                              if(richTick.isTextVisible === true) {
                                  return d3.timeFormat("%b %d")(a)
                              }
                              
                          }))
//                const after = g.selectAll("[isXTickAxis=true]")
//                log.debug("drawChart(): DEL: after isXTickAxis =", after)
//
//                const afterTicks = after.selectAll(".tick")
//                log.debug("drawChart(): DEL: afterTicks =", afterTicks)
//            } else {
//                log.debug("drawChart(): DEL: --------------------")
//                log.debug("drawChart(): DEL: NOT FIRST TIME")
//                log.debug("drawChart(): DEL: --------------------")
//                log.debug("drawChart(): DEL: before =", before)
//            }
            
            const yAxisTransform = this.createTransform(
//                0,
                //                this.dims.paint.height + 10
                -3, // move left
                4  //
            )
            
            g.append("g")
	        .attr("transform",yAxisTransform)
                .attr("class", classes.yTimeAxis)
                .style("marginTop", "50px")
                .call(d3.axisLeft(yTimeScale)
                      .tickValues(yTickValues)
	              .tickFormat(v => {
                          return Number(v)
                      })
                     )
//	              .tickFormat(d3.timeFormat("%B %d")))
//                .call(d3.axisLeft(yTimeScale))


            

            // next
            

            const trendTransform = this.createTransform(0,this.dims.bar1.spacing/2)

//            const toRemove = g.selectAll("g")
            //            log.debug("drawChart(): DEL: circle.x 3: x =", x)

            // next: d3 remove before append, replace, force update
            
            
            // multiple trends
            const chartContainers =g.append("g")
                .attr("id", "multi-chart-g")
                .selectAll("g")
                .data(this.dataset)
                .enter()
                .append("g")
                .attr("id", d => {
                    return `chart-${d.letter}-container-g`
                })
//                  .exit()
//                  .remove()

            // paths
            const prevPaths =
                  svg
                  .selectAll("#multi-chart-g")
                  .selectAll("#chart-line-path")
            log.trace("drawChart(): DEL: prevPaths =", prevPaths)

            //prevPaths.remove()
            
            // chartContainers.selectAll("g").remove() // reset the chart


            //
            // PATHS
            //
            // this is bound to trend, so we'll alwasy have a trend here
            chartContainers.append("g")
                .attr("id", d => {
                    return `chart-${d.letter}-path-g`
                })
                .attr("class", classes.trend1Line)
                .classed(classes.trend1LineEmpty, startEmpty)
                .append("path")
	        .attr('d', d => {
                    const path = lineGenerator(d.trend1)
                    log.trace("drawChart(): DEL: generating path =", path)
                    //lineGenerator(d.trend1)
                    return path
                }
                )
	        .attr("transform", trendTransform)
                .attr("id", "chart-line-path")
            
            // circles
            // paths
            /*
            const prevCircles =
                  svg
                  .selectAll("#multi-chart-g")
                  .selectAll("#chart-line-circle")
            log.debug("drawChart(): DEL: prevCircles =", prevCircles)
            //zprevCircles.remove()
            prevCircles.attr("prev", true)
            */

            const timestamp = (new Date()).toISOString()
            log.debug("drawChart(): DEL: timestamp =", timestamp)
            
            chartContainers.append("g")
                .attr("id", d => {
                    return `chart-${d.letter}-circles-g`
                })
                .attr("class", classes.trend1Circle) // default, more below
                .classed(classes.trend1CircleEmpty, startEmpty)
                .selectAll("circle")
                .data(d => {
                    return d.trend1
                })
                .enter()
                .append("circle")
            	.attr('cx', (d, i) => {
                    //log.debug("drawChart(): DEL: circle.x 1: d =", d)
                    //log.debug("drawChart(): DEL: circle.x 2: i =", i)
                    const x = xTimeScale(d.flashTimestamp)
	            //return xTimeScale(d.flashTimestamp)

                    //log.debug("drawChart(): DEL: circle.x 3: x =", x)
                    
                    return x
	        })
            	.attr('cy', (d, i) => {
                    //log.debug("drawChart(): DEL: circle.y 1: d =", d)
                    //log.debug("drawChart(): DEL: circle.y 2: i =", i)
                    const y = yTimeScale(d.value)
	            //return xTimeScale(d.flashTimestamp)

                    //log.debug("drawChart(): DEL: circle.y 3: y =", y)

                    return y
                    //return 177
                    //return yTimeScale(d.value)
	        })
	        .attr('r', 5)
    	        .attr("transform", trendTransform)
                .classed(classes.trend1CircleLastWeek, d => {
                    if(d.flashItemType === "lastWeek")
                        return true
                    else
                        return false
                })
                .classed(classes.trendCircleUp, d => {
                    if(d.flashItemType === "current") {
                        if(!reverseY) {
                            if(d.flashItemDirection === "up") {
                                return true
                            }
                        } else {
                            if(d.flashItemDirection === "down") {
                                return true
                            }
                        }
                    }
                    return false
                })
                .classed(classes.trendCircleDown, d => {
                    if(d.flashItemType === "current") {
                        if(!reverseY) {
                            if(d.flashItemDirection === "down") {
                                return true
                            }
                        } else {
                            if(d.flashItemDirection === "up") {
                                return true
                            }
                        }
                    }
                    return false
                })
                .classed(classes.trendCircleSame, d => {
                    if(d.flashItemType === "current") {
                        if(d.flashItemDirection === "same") {
                            return true
                        }
                    }
                    return false
                })
                .attr("id", "chart-line-circle")
                .attr("timestamp", timestamp)
//                .exit()
//                .remove()



//            const prevCircles =
//                  svg
//                  .selectAll("#multi-chart-g")
//                  .selectAll("#chart-line-circle")
//                  .exit()
//
//            log.debug("drawChart(): DEL: prevCircles =", prevCircles)
//            //zprevCircles.remove()
//            prevCircles.attr("prev", true)


            
                         
            /*
	        .style("fill", d => {
	            log.trace("fill: flashItemNumber =", d.flashItemNumber)
	            log.trace("fill: d =", d)
	            if(d.flashItemType && d.flashItemType === "current") {
		        if(d.flashItemDirection === "up") {
		            return "green"
		        } else if(d.flashItemDirection === "down") {
		            return "red"
		        } else {
		            return "black" // would be for "same" or nothing
		        }
	            } else if(d.flashItemType && d.flashItemType === "lastWeek") {
		        return "yellow"
	            } else {
		        return undefined
	            }
	        })
	        .style("stroke", d => {
	            if(d.flashItemType && d.flashItemType === "lastWeek") {
		        return "grey"
	            } else {
		        return undefined
	            }
	        })
            */
        }


        /*
        // listener on top of bars, without zinde
        g.selectAll(".listener")
            .data(this.dataset)
            .enter()
//            .data(d => {
//                log.trace("sdflkjsdf")
//            })
            .append("rect")
            .attr("class", classes.listener)
            .attr("x", -this.dims.paint.margin.left) // ignore the margin, all the way left
            .attr("y", d => yListener(d.name) - this.dims.paint.margin.top)
            .attr("width", this.dims.chart.width)
            .attr("height", yListener.bandwidth()) // NEXT: this is correct, continue here
        */
    }

    

    highlight(highlights) {
        log.trace("highlight(): highlights = ", highlights)

         let pathG_Id,
            circlesG_Id

        const itemUUID = highlights[0].letter
        log.trace("highlight(): itemUUID = ", itemUUID)
        
        pathG_Id = `chart-${itemUUID}-path-g`
        circlesG_Id = `chart-${itemUUID}-circles-g`

        log.trace("highlight(): pathG_Id = ", pathG_Id)

        const { classes, showHighlights } = this.props

        if(showHighlights) {
            const pathG = d3.select(`#${pathG_Id}`)
                  .classed(classes.trend1LineHighlight, true)
                  .attr("isHighlighted", true)
            log.trace("highlight(): showing highlight pathG = ", pathG)

            const circlesG = d3.select(`#${circlesG_Id}`)
                  .classed(classes.trend1CircleHighlight, true)
                  .attr("isHighlighted", true)// continue here
            log.trace("highlight(): showing highlight circlesG = ", circlesG)
        }
    }

    unhighlight(highlights) {
        log.trace("unhighlight()")

        const { classes,
//                showHighlights,
//                startEmpty
              } = this.props
        
        //        d3.select("#chart-A-path-g")
        //            .classed(classes.trend1LineHighlight, false)
        //
        //        d3.select("#chart-B-path-g")
        //            .classed(classes.trend1LineHighlight, false)

        const highs = d3.selectAll("[isHighlighted=true]")
        log.trace("unhighlight(): highs = ", highs)
        highs
            .classed(classes.trend1LineHighlight, false)
            .classed(classes.trend1CircleHighlight, false)
            .attr("isHighlighted", false)

    }

    componentDidUpdate(prevProps) {
        log.trace("componentDidUpdate(): prevProps.dataset =", prevProps.dataset)
        log.trace("componentDidUpdate(): this.props.dataset =", this.props.dataset)
        if(!_.isEqual(this.props.dataset, prevProps.dataset)) {
            log.trace("componentDidUpdate(): DEL: NEW DATASET")
            this.superset = this.props.superset
            this.dataset = this.props.dataset
            //this.resetChart()
            this.drawChart()
        }

        // chart-california-gas-prices-sd13-14915x-path-g

        
        const { highlights } = this.props
        
        if(highlights !== prevProps.highlights) {
            log.trace("componentDidUpdate(): highlights = ", highlights)
            if(highlights && highlights.length) {
                this.highlight(highlights)
            } else if(highlights) {
                this.unhighlight()
            }
        }
    }


    componentDidMount() {
        log.trace("componentDidMount(): this.dataset =", this.dataset)
        log.trace("componentDidMount(): this.dataset.length =", this.dataset.length)
        
        // TODO: see what's really going on here
        if(this.dataset && this.dataset[0] && this.dataset.length > 0)
            this.drawChart()
    }

    
    render() {

        const { classes } = this.props

	return (
            <div ref="chartDiv" id="chartDiv" className={classes.chartDiv} onClick={this.handleChartClick}>
              <div id="tooltip" className={classes.tooltip}>
                <div id="name">name</div>
                <div id="col1">count</div>
                <div id="states">states</div>
                <div id="uscds">uscds</div>
                <div className={classes.tooltipAnchor}></div>
              </div>
              <svg ref="chartSvg" id="chartSvg" className={classes.chartSvg}/>
            </div>
	)
    }

}

DashLineChart.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withStyles(styles, {name: "DashLineChart"})(DashLineChart)
